import type { SVGProps } from "react";
const SenecPictogramPlugSchucko = (props: Pick<SVGProps<SVGSVGElement>, "color">) => (
    <svg width={48} height={48} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 24C12 21.7909 13.7909 20 16 20C18.2091 20 20 21.7909 20 24C20 26.2091 18.2091 28 16 28C13.7909 28 12 26.2091 12 24ZM16 22C14.8954 22 14 22.8954 14 24C14 25.1046 14.8954 26 16 26C17.1046 26 18 25.1046 18 24C18 22.8954 17.1046 22 16 22Z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M28 24C28 21.7909 29.7909 20 32 20C34.2091 20 36 21.7909 36 24C36 26.2091 34.2091 28 32 28C29.7909 28 28 26.2091 28 24ZM32 22C30.8954 22 30 22.8954 30 24C30 25.1046 30.8954 26 32 26C33.1046 26 34 25.1046 34 24C34 22.8954 33.1046 22 32 22Z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M22 4.06445V10.0001C22 11.1046 22.8954 12.0001 24 12.0001C25.1046 12.0001 26 11.1046 26 10.0001V4.06445L27.1567 4.24792C32.9994 5.17468 37.9997 8.63069 41 13.4591V19H44V29H41V34.541C37.9997 39.3694 32.9994 42.8255 27.1567 43.7522L26 43.9357V38C26 36.8954 25.1046 36 24 36C22.8954 36 22 36.8954 22 38V43.9357L20.8433 43.7522C15.0006 42.8255 10.0003 39.3694 7 34.541V29H4V19H7V13.4591C10.0003 8.63069 15.0006 5.17468 20.8433 4.24792L22 4.06445ZM39 33.9534V27H42V21H39V14.0468C36.4833 10.2614 32.5721 7.48312 28 6.44588V10.0001C28 12.2092 26.2091 14.0001 24 14.0001C21.7909 14.0001 20 12.2092 20 10.0001V6.44588C15.4279 7.48312 11.5167 10.2614 9 14.0468V21H6V27H9V33.9534C11.5167 37.7387 15.4279 40.517 20 41.5543V38C20 35.7908 21.7909 34 24 34C26.2091 34 28 35.7908 28 38V41.5543C32.5721 40.517 36.4833 37.7387 39 33.9534Z"
            fill="currentColor"
        />
    </svg>
);
export default SenecPictogramPlugSchucko;
